const $ = require('jquery');
import run from '../../utilities/run';
import render from "../../utilities/render";
import { setElementsFromScope } from '../../utilities/selectorHelpers';
// @grant window.close


const targetSelector = "#merchantOnboardingWrapper";

// Modal Html to use
require("./returnsTechnologyRegistration.less")
run(targetSelector, (el)=>{
  attachStubExample(el);
});

 function attachStubExample(el) {
  // START: REQUIRED TO LOAD STUB
  const mainHtml = render(
    require("./html/onboarding-welcome-production.html"), {
  }
  );
  const mainEl = $(mainHtml);
  const entryEl = $("<div class='entry-point'></div>");

  $(el).html(entryEl);
  entryEl.append(mainEl);
  // END: REQUIRED TO LOAD STUB

  // START: REAL CODE
  console.log('before START');
  let els = {};
  let elsMap = {
    viewArticlesAcceptanceBtn:'.view-articles-acceptance',
    acceptBtn:'.accept-btn',
    userAcceptanceSection:'.user-acceptance-section',
    getStartedSection:'.get-started-section',
    notAcceptBtn:'.not-accept-btn',
    nextBtn:'.self-initial-reg-next-btn'
  };

  function init() {
    setElements();
    bindElements();
    els.userAcceptanceSection.hide();
    // Stack function calls here.

  }

  function setElements() {
    setElementsFromScope(els, elsMap, mainEl);
    // Can call multiple setElementsFromScope for multiple elsMap.
  }

  function bindElements() {
    els.viewArticlesAcceptanceBtn.on("click", function(){
      els.userAcceptanceSection.show();
      els.getStartedSection.hide();
    });

    els.acceptBtn.on("click", function(){
      els.getStartedSection.hide();
     $(".self-initial-reg-next-btn").removeClass('disabled');
     els.userAcceptanceSection.hide();
     els.getStartedSection.show();
     els.viewArticlesAcceptanceBtn.hide();
    });
  
    els.notAcceptBtn.on("click", function(){ 
      //els.userAcceptanceSection.hide();
      //els.getStartedSection.show();
     // els.viewArticlesAcceptanceBtn.show();
     window.close();
    });

    els.nextBtn.on("click", function(e){
      processNextButton();
    });
    
    const initialRegistrationPage = $("#merchantOnboardingWrapper").data("initial-registration-page-url");
    function processNextButton() {
      //location.href = initialRegistrationPage;
      var newwindow = window.open(initialRegistrationPage, '_self','height=20,width=15');
     if (window.focus) {newwindow.focus()}

    }
    
  }

  init();

  // END: REAL CODE
};


// WEBPACK FOOTER //
// ./src/pages/rmaMerchantSelfOnboarding/rmaMerchantSelfOnboardingProduction.js